import ThemeConfig from "@mobiusjs/site-client/dist/ClientThemeConfig";

export default ThemeConfig.customize(ThemeConfig, {
    styles: ['fonts/fonts', 'splide', 'theme'],
    scripts: ['runtime', 'mod', 'mod.react', 'lib', 'theme']
});
